<template>
  <div id="powered-by-mikmak-white" class="powered-by-mikmak-white">
    <label class="powered-by-mikmak-text">{{ poweredByText }}</label>
    <img src="../assets/mikmak-logo-white.png" alt="powered by MikMak">
  </div>
</template>

<script>

  import utils from '../lib/utils'

  export default {
    props: [],
    mounted() {},
    computed: {
      currentVideoCanPlay() {
        return this.$store.state.currentVideoCanPlay
      },
      poweredByText() {
        return utils.getConstantKeyFromStore(this.$store.state, 'POWERED_BY_TEXT')
      }
    },
    methods: {},
    watch: {}
  }
</script>

<style scoped>
  .powered-by-mikmak-white {
    display: block;
    z-index: 3;
    bottom: 0px;
    position: fixed;
    width: 100%;
    padding: 24px 0;
  }

  .powered-by-mikmak-white img {
    height: 42px;
    margin-bottom: -8px;
    margin-left: 4px;
  }

  .powered-by-mikmak-text {
    display: inline-block;
    color: white;
    text-shadow: 0 0 4px #929292;
    font-style: italic;
    font-size: 16px;
    vertical-align: middle;
    margin-top: -6px;
    margin-right: -6px;
    font-family: "Helvetica", sans-serif;
    font-weight: 200;
  }

</style>



// WEBPACK FOOTER //
// PoweredByMikMak.vue?167813cf